export const selectDataBreachNotificationIncidentResponseCase = (state) =>
  state.privacyKitDataBreachNotification.incidentResponseCase;

export const selectDataBreachNotificationIncidentResponseCaseStageId = (
  state
) => state.privacyKitDataBreachNotification.incidentResponseCase?.stageId ?? null;
